export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-16 bg-background-100">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="bg-background-50 rounded-2xl border border-background-200/60 p-7 md:p-10 flex flex-col md:flex-row items-center gap-6 md:gap-10">
          <div className="w-16 h-16 md:w-20 md:h-20 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0">
            <i className="ri-mail-send-line text-2xl md:text-3xl text-primary-500"></i>
          </div>

          <div className="flex-1 text-center md:text-left">
            <h2 className="text-xl md:text-2xl font-heading text-foreground-950 mb-2">投稿咨询</h2>
            <p className="text-sm text-foreground-600 leading-relaxed">
              如果您是漫画创作者、汉化组或版权方，欢迎通过以下方式联系我们进行投稿合作与版权咨询。99漫画致力于为读者提供正版、优质的免费漫画阅读体验，期待与您携手为广大漫迷带来更多精彩内容。
            </p>
          </div>

          <div className="flex-shrink-0 flex flex-col sm:flex-row items-stretch sm:items-center gap-3">
            <div className="flex items-center gap-2 text-sm text-foreground-600 bg-background-100 rounded-lg px-4 py-2.5">
              <i className="ri-mail-line text-primary-500"></i>
              <span>投稿：contact@99manhua.com</span>
            </div>
            <div className="flex items-center gap-2 text-sm text-foreground-600 bg-background-100 rounded-lg px-4 py-2.5">
              <i className="ri-wechat-line text-green-500"></i>
              <span>微信：99漫画官方</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}